import { createReducer } from '@reduxjs/toolkit';
import { StorageKeyEnum } from 'enums/StorageKeyEnum';
import { getItem, removeItems, setItem } from 'utils/handlers/storageHandler';
import {
  chooseKenticoProject,
  getProjectPrefixSuccess,
  getUserConfigSuccess,
  loginSuccess,
  logoutUserSuccess,
  refreshTokenSuccess,
} from './auth.actions';
import { IAuthState } from './auth.interface';

const initState: IAuthState = {
  isLoggedIn: false,
  chosenProject: false,
  isDirty: false,
  projectName: '',
  projectId: '',
  projectPrefix: '',
  allowDueDateChange: false,
};

export const authReducer = createReducer(initState, (builder) =>
  builder
    .addCase(logoutUserSuccess, (state) => {
      state.chosenProject = false;
      state.isDirty = true;
      state.data = undefined;
      removeItems([StorageKeyEnum.projectId, StorageKeyEnum.projectName]);
    })
    .addCase(refreshTokenSuccess, (state, { payload }) => {
      state.isLoggedIn = true;
      state.isDirty = true;
      state.data = payload;
      state.chosenProject = Boolean(getItem(StorageKeyEnum.projectId));
      state.projectId = getItem(StorageKeyEnum.projectId) || '';
      state.projectName = getItem(StorageKeyEnum.projectName) || '';
    })
    .addCase(loginSuccess, (state, { payload }) => {
      state.isLoggedIn = true;
      state.isDirty = true;
      state.data = payload;
    })
    .addCase(chooseKenticoProject, (state, { payload: { id, kenticoProjectName } }) => {
      setItem(StorageKeyEnum.projectId, id);
      setItem(StorageKeyEnum.projectName, kenticoProjectName);
      state.projectId = id;
      state.projectName = kenticoProjectName;
      state.chosenProject = true;
    })
    .addCase(getProjectPrefixSuccess, (state, { payload: { prefix } }) => {
      state.projectPrefix = prefix;
    })
    .addCase(getUserConfigSuccess, (state, { payload: { allowDueDateChange, daysToDefaultDueDate } }) => {
      state.allowDueDateChange = allowDueDateChange;
      state.daysToDefaultDueDate = daysToDefaultDueDate;
    }),
);
